import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wage-whole-version" }
const _hoisted_2 = { class: "whole-version-header" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "employee-count" }
const _hoisted_5 = { class: "whole-version-body" }
const _hoisted_6 = { class: "table-scroll-container" }
const _hoisted_7 = { class: "whole-version-table" }
const _hoisted_8 = { class: "sticky-col col-name" }
const _hoisted_9 = { class: "name-cell" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = {
  key: 0,
  class: "badge"
}
const _hoisted_12 = {
  key: 1,
  class: "badge family"
}
const _hoisted_13 = { class: "col-info" }
const _hoisted_14 = { class: "col-info" }
const _hoisted_15 = { class: "col-hours" }
const _hoisted_16 = { class: "col-money" }
const _hoisted_17 = { class: "col-money group-end" }
const _hoisted_18 = { class: "col-money" }
const _hoisted_19 = { class: "col-money" }
const _hoisted_20 = { class: "col-money" }
const _hoisted_21 = { class: "col-money" }
const _hoisted_22 = { class: "col-money" }
const _hoisted_23 = { class: "col-money" }
const _hoisted_24 = { class: "col-money" }
const _hoisted_25 = { class: "col-money" }
const _hoisted_26 = { class: "col-money group-end" }
const _hoisted_27 = { class: "col-money col-total group-end" }
const _hoisted_28 = { class: "col-money" }
const _hoisted_29 = { class: "col-money group-end" }
const _hoisted_30 = { class: "col-money col-deduction" }
const _hoisted_31 = { class: "col-money col-deduction" }
const _hoisted_32 = { class: "col-money col-deduction" }
const _hoisted_33 = { class: "col-money col-deduction" }
const _hoisted_34 = { class: "col-money col-deduction" }
const _hoisted_35 = { class: "col-money col-deduction" }
const _hoisted_36 = { class: "col-money col-deduction" }
const _hoisted_37 = { class: "col-money col-deduction" }
const _hoisted_38 = { class: "col-money col-deduction" }
const _hoisted_39 = { class: "col-money col-subtotal group-end" }
const _hoisted_40 = { class: "col-money col-deduction" }
const _hoisted_41 = { class: "col-money col-deduction" }
const _hoisted_42 = { class: "col-money col-deduction" }
const _hoisted_43 = { class: "col-money col-deduction" }
const _hoisted_44 = { class: "col-money col-deduction" }
const _hoisted_45 = { class: "col-money col-deduction" }
const _hoisted_46 = { class: "col-money col-deduction" }
const _hoisted_47 = { class: "col-money col-subtotal group-end" }
const _hoisted_48 = { class: "col-money col-net" }
const _hoisted_49 = { style: {"border-collapse":"separate"} }
const _hoisted_50 = { class: "total-row" }
const _hoisted_51 = { class: "col-hours" }
const _hoisted_52 = { class: "col-money group-end" }
const _hoisted_53 = { class: "col-money" }
const _hoisted_54 = { class: "col-money" }
const _hoisted_55 = { class: "col-money" }
const _hoisted_56 = { class: "col-money" }
const _hoisted_57 = { class: "col-money" }
const _hoisted_58 = { class: "col-money" }
const _hoisted_59 = { class: "col-money" }
const _hoisted_60 = { class: "col-money" }
const _hoisted_61 = { class: "col-money group-end" }
const _hoisted_62 = { class: "col-money col-total group-end" }
const _hoisted_63 = { class: "col-money" }
const _hoisted_64 = { class: "col-money group-end" }
const _hoisted_65 = { class: "col-money col-deduction" }
const _hoisted_66 = { class: "col-money col-deduction" }
const _hoisted_67 = { class: "col-money col-deduction" }
const _hoisted_68 = { class: "col-money col-deduction" }
const _hoisted_69 = { class: "col-money col-deduction" }
const _hoisted_70 = { class: "col-money col-deduction" }
const _hoisted_71 = { class: "col-money col-deduction" }
const _hoisted_72 = { class: "col-money col-deduction" }
const _hoisted_73 = { class: "col-money col-deduction" }
const _hoisted_74 = { class: "col-money col-subtotal group-end" }
const _hoisted_75 = { class: "col-money col-deduction" }
const _hoisted_76 = { class: "col-money col-deduction" }
const _hoisted_77 = { class: "col-money col-deduction" }
const _hoisted_78 = { class: "col-money col-deduction" }
const _hoisted_79 = { class: "col-money col-deduction" }
const _hoisted_80 = { class: "col-money col-deduction" }
const _hoisted_81 = { class: "col-money col-deduction" }
const _hoisted_82 = { class: "col-money col-subtotal group-end" }
const _hoisted_83 = { class: "col-money col-net" }

import { computed, watch } from 'vue';

interface PatientInfo {
  patientCode: string;
  patientName: string;
  sugaCode: string;
  sugaName: string;
  sugaMinutesKey: number | null;
  timePay: string;
  serviceDays: number;
  sugaHours: number;
  totalSugaMoney: number;
  lunchTimeCount: number;
}

interface GroupedMember {
  empCode: string;
  name: string;
  birth: string;
  gender: string;
  license: string;
  workStartDate: string;
  workEndDate: string;
  patients: PatientInfo[];
  originalItems: any[];
  totalSugaMoney: number;
  totalLunchTimeCount: number;
  isBoss: boolean;
}

interface SettingsItem {
  applyNationalPension: boolean;
  yeonPay: string;
  applyBoninPay: boolean;
  boninPay: string;
  applyHealthInsurance: boolean;
  applyEmploymentInsurance: boolean;
  applyUnemployment: boolean;
  applyRetirement: boolean;
  applyHoliday: boolean;
  applyOvertime: boolean;
  applyMeal: boolean;
  applyLongServicePay: boolean;
  longServicePay: string;
  applyBosuEduPay: boolean;
  bosuEduPay: string;
  applyEmpEtc: boolean;
  empEtc: string;
  timePays: Record<string, Record<string, string>>;
  customSugaHours: Record<string, Record<string, number>>;
  sugaHoursChanged: boolean;
}

interface Props {
  modelValue: boolean;
  groupedMemberData: GroupedMember[];
  payrollDetails: Record<number, any>;
  settingsData: Record<number, SettingsItem>;
  yearMonth?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WageWholeVersion',
  props: {
    modelValue: { type: Boolean },
    groupedMemberData: {},
    payrollDetails: {},
    settingsData: {},
    yearMonth: {}
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const close = () => {
  dialogVisible.value = false;
  emit('close');
};

const formatMoney = (amount: number | undefined) => {
  if (!amount) return '0';
  return new Intl.NumberFormat('ko-KR').format(amount);
};

const formatSugaHours = (hours: number) => {
  if (!hours) return '0시간';
  if (hours % 1 === 0) {
    return `${hours}시간`;
  }
  return `${hours.toFixed(1)}시간`;
};

const calculateAge = (birthDateStr: string, baseYm: string) => {
  if (!birthDateStr || !baseYm) return 0;
  const birthDate = new Date(birthDateStr);
  const baseYear = parseInt(baseYm.substring(0, 4));
  const baseMonth = parseInt(baseYm.substring(4, 6));
  const baseDate = new Date(baseYear, baseMonth, 0);
  let age = baseDate.getFullYear() - birthDate.getFullYear();
  if (
    baseDate.getMonth() < birthDate.getMonth() ||
    (baseDate.getMonth() === birthDate.getMonth() && baseDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

const getAge = (group: GroupedMember) => {
  return calculateAge(group.birth, props.yearMonth || '');
};

const calculateWorkPeriod = (startDateStr: string, baseYm: string) => {
  if (!startDateStr || !baseYm) return { years: 0, months: 0 };
  const workStartDate = new Date(startDateStr);
  const baseYear = parseInt(baseYm.substring(0, 4));
  const baseMonth = parseInt(baseYm.substring(4, 6));
  const baseDate = new Date(baseYear, baseMonth - 1, 1);
  let years = baseDate.getFullYear() - workStartDate.getFullYear();
  let months = baseDate.getMonth() - workStartDate.getMonth();
  if (months < 0) {
    years--;
    months += 12;
  }
  return { years, months };
};

const getWorkPeriodText = (group: GroupedMember) => {
  const period = calculateWorkPeriod(group.workStartDate, props.yearMonth || '');
  if (period.years > 0) {
    return `${period.years}년${period.months}월`;
  }
  return `${period.months}개월`;
};

const getSugaKey = (patient: PatientInfo): string => {
  const hoursKey = patient.sugaHours ? `_h${patient.sugaHours}` : '';
  if (patient.sugaMinutesKey != null) {
    return `${patient.sugaCode}_${patient.sugaMinutesKey}${hoursKey}`;
  }
  return `${patient.sugaCode}${hoursKey}`;
};

const is270MinutesOverSuga = (patient: { sugaName?: string; sugaMinutesKey?: number | null }) => {
  return patient.sugaMinutesKey != null || (patient.sugaName && patient.sugaName.includes('270분초과'));
};

// 8시간 초과 시에는 휴게시간 차감 없음
const getPatientSugaHours = (patient: { sugaName?: string; sugaHours?: number; sugaMinutesKey?: number | null }) => {
  const baseHours = patient.sugaHours || 0;
  if (is270MinutesOverSuga(patient)) {
    if (baseHours > 8) {
      return baseHours; // 8시간 초과 시 휴게시간 차감 없음
    }
    return Math.max(0, baseHours - 0.5);
  }
  return baseHours;
};

const getTotalSugaHours = (group: GroupedMember, groupIndex: number) => {
  let totalHours = 0;
  group.patients.forEach((patient) => {
    let sugaHours: number;
    const settings = props.settingsData[groupIndex];
    const sugaKey = getSugaKey(patient);
    if (settings?.customSugaHours?.[patient.patientCode]?.[sugaKey] !== undefined) {
      sugaHours = settings.customSugaHours[patient.patientCode][sugaKey];
    } else {
      sugaHours = getPatientSugaHours(patient);
    }
    totalHours += (patient.serviceDays || 0) * sugaHours;
  });
  return totalHours;
};

const isAllFamilyCaregiver = (group: GroupedMember): boolean => {
  if (!group || !group.patients || group.patients.length === 0) return false;
  return group.patients.every((patient) => {
    const sugaName = patient.sugaName || '';
    return sugaName.includes('가족');
  });
};

const calculateCenterProfit = (group: GroupedMember, groupIndex: number) => {
  const payroll = props.payrollDetails[groupIndex];
  if (!payroll) return 0;
  const totalSugaMoney = (group.totalSugaMoney || 0) + (payroll.severeCareAddition || 0);  // 중증수급자 가산 포함
  const monthlyPay = payroll.totalPay || 0;
  const centerDeduction = payroll.totalCenterDeduction || 0;
  return totalSugaMoney - monthlyPay - centerDeduction;
};

const getProfitClass = (group: GroupedMember, groupIndex: number) => {
  const profit = calculateCenterProfit(group, groupIndex);
  return { positive: profit > 0, negative: profit < 0 };
};

const getTotalAllSugaHours = () => {
  let total = 0;
  props.groupedMemberData.forEach((group, index) => {
    total += getTotalSugaHours(group, index);
  });
  return total;
};

const getTotalAllSugaMoney = () => {
  let total = 0;
  props.groupedMemberData.forEach((group, index) => {
    total += (group.totalSugaMoney || 0) + (props.payrollDetails[index]?.severeCareAddition || 0);
  });
  return total;
};

const getSumField = (fieldName: string) => {
  let total = 0;
  Object.values(props.payrollDetails).forEach((payroll: any) => {
    if (payroll && payroll[fieldName] !== undefined) {
      total += payroll[fieldName] || 0;
    }
  });
  return total;
};

const getSumNestedField = (parentField: string, childField: string) => {
  let total = 0;
  Object.values(props.payrollDetails).forEach((payroll: any) => {
    if (payroll && payroll[parentField] && payroll[parentField][childField] !== undefined) {
      total += payroll[parentField][childField] || 0;
    }
  });
  return total;
};

const getTotalCenterProfit = () => {
  let total = 0;
  props.groupedMemberData.forEach((group, index) => {
    total += calculateCenterProfit(group, index);
  });
  return total;
};

const getTotalProfitClass = () => {
  const profit = getTotalCenterProfit();
  return { positive: profit > 0, negative: profit < 0 };
};

return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "95vw"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "전체 급여 상세", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.groupedMemberData.length) + "명", 1)
          ]),
          _createElementVNode("button", {
            class: "btn-close",
            onClick: close
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: "sticky-col col-name"
                  }, "성명"),
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: "col-info"
                  }, "나이"),
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: "col-info"
                  }, "근속"),
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: "col-hours"
                  }, "수가시간"),
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: ""
                  }, "시급"),
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: "group-end"
                  }, "총수가"),
                  _createElementVNode("th", {
                    colspan: "9",
                    class: "group-header"
                  }, "급여 및 수당"),
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: "col-total group-end"
                  }, "총급여"),
                  _createElementVNode("th", {
                    colspan: "2",
                    class: "group-header"
                  }, "과세/비과세"),
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: "col-profit group-end"
                  }, "기관수익"),
                  _createElementVNode("th", {
                    colspan: "10",
                    class: "group-header"
                  }, "근로자 공제"),
                  _createElementVNode("th", {
                    colspan: "8",
                    class: "group-header"
                  }, "기관 공제"),
                  _createElementVNode("th", {
                    rowspan: "2",
                    class: "col-net"
                  }, "실수령액")
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "sub-header" }, "기본급"),
                  _createElementVNode("th", { class: "sub-header" }, "주휴수당"),
                  _createElementVNode("th", { class: "sub-header" }, "연차수당"),
                  _createElementVNode("th", { class: "sub-header" }, "식대"),
                  _createElementVNode("th", { class: "sub-header" }, "장기근속"),
                  _createElementVNode("th", { class: "sub-header" }, "보수교육비"),
                  _createElementVNode("th", { class: "sub-header" }, "중증가산"),
                  _createElementVNode("th", { class: "sub-header" }, "휴일수당"),
                  _createElementVNode("th", { class: "sub-header group-end" }, "연장수당"),
                  _createElementVNode("th", { class: "sub-header" }, "과세"),
                  _createElementVNode("th", { class: "sub-header group-end" }, "비과세"),
                  _createElementVNode("th", { class: "sub-header" }, "국민연금"),
                  _createElementVNode("th", { class: "sub-header" }, "건강보험"),
                  _createElementVNode("th", { class: "sub-header" }, "장기요양"),
                  _createElementVNode("th", { class: "sub-header" }, "고용보험"),
                  _createElementVNode("th", { class: "sub-header" }, "소득세"),
                  _createElementVNode("th", { class: "sub-header" }, "지방세"),
                  _createElementVNode("th", { class: "sub-header" }, "본인부담금"),
                  _createElementVNode("th", { class: "sub-header" }, "기타공제"),
                  _createElementVNode("th", { class: "sub-header" }, "지원공제"),
                  _createElementVNode("th", { class: "sub-header group-end" }, "공제합계"),
                  _createElementVNode("th", { class: "sub-header" }, "국민연금"),
                  _createElementVNode("th", { class: "sub-header" }, "건강보험"),
                  _createElementVNode("th", { class: "sub-header" }, "장기요양"),
                  _createElementVNode("th", { class: "sub-header" }, "고용보험"),
                  _createElementVNode("th", { class: "sub-header" }, "실업급여"),
                  _createElementVNode("th", { class: "sub-header" }, "산재보험"),
                  _createElementVNode("th", { class: "sub-header" }, "퇴직금"),
                  _createElementVNode("th", { class: "sub-header group-end" }, "공제합계")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groupedMemberData, (group, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(group.name), 1),
                        (group.isBoss)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "대표"))
                          : _createCommentVNode("", true),
                        (isAllFamilyCaregiver(group))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "가족"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(getAge(group)) + "세", 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(getWorkPeriodText(group)), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(formatSugaHours(getTotalSugaHours(group, index))), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(formatMoney(__props.payrollDetails[index]?.avgTimePay)), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(formatMoney((group.totalSugaMoney || 0) + (__props.payrollDetails[index]?.severeCareAddition || 0))), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(formatMoney(__props.payrollDetails[index]?.basicPay)), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(formatMoney(__props.payrollDetails[index]?.holidayPay)), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(formatMoney(__props.payrollDetails[index]?.vacationPay)), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(formatMoney(__props.payrollDetails[index]?.mealAllowance)), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(formatMoney(__props.payrollDetails[index]?.longServicePay)), 1),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(formatMoney(__props.payrollDetails[index]?.bosuEduPay)), 1),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(formatMoney(__props.payrollDetails[index]?.severeCareAddition)), 1),
                    _createElementVNode("td", _hoisted_25, _toDisplayString(formatMoney(__props.payrollDetails[index]?.holidayAllowance)), 1),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(formatMoney(__props.payrollDetails[index]?.overtimeAllowance)), 1),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(formatMoney(__props.payrollDetails[index]?.totalPay)), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(formatMoney(__props.payrollDetails[index]?.taxableAmount)), 1),
                    _createElementVNode("td", _hoisted_29, _toDisplayString(formatMoney(__props.payrollDetails[index]?.nonTaxableAmount)), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(["col-money col-profit group-end", getProfitClass(group, index)])
                    }, _toDisplayString(formatMoney(calculateCenterProfit(group, index))), 3),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(formatMoney(__props.payrollDetails[index]?.employeeDeductions?.nationalPension)), 1),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(formatMoney(__props.payrollDetails[index]?.employeeDeductions?.healthInsurance)), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(formatMoney(__props.payrollDetails[index]?.employeeDeductions?.longTermCare)), 1),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(formatMoney(__props.payrollDetails[index]?.employeeDeductions?.employmentInsurance)), 1),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(formatMoney(__props.payrollDetails[index]?.employeeDeductions?.incomeTax)), 1),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(formatMoney(__props.payrollDetails[index]?.employeeDeductions?.localTax)), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(formatMoney(__props.payrollDetails[index]?.boninPayAmount)), 1),
                    _createElementVNode("td", _hoisted_37, _toDisplayString(formatMoney(__props.payrollDetails[index]?.empEtcAmount)), 1),
                    _createElementVNode("td", _hoisted_38, _toDisplayString(formatMoney(__props.payrollDetails[index]?.supportDeduction)), 1),
                    _createElementVNode("td", _hoisted_39, _toDisplayString(formatMoney(__props.payrollDetails[index]?.totalEmployeeDeduction)), 1),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(formatMoney(__props.payrollDetails[index]?.centerDeductions?.nationalPension)), 1),
                    _createElementVNode("td", _hoisted_41, _toDisplayString(formatMoney(__props.payrollDetails[index]?.centerDeductions?.healthInsurance)), 1),
                    _createElementVNode("td", _hoisted_42, _toDisplayString(formatMoney(__props.payrollDetails[index]?.centerDeductions?.longTermCare)), 1),
                    _createElementVNode("td", _hoisted_43, _toDisplayString(formatMoney(__props.payrollDetails[index]?.centerDeductions?.employmentInsurance)), 1),
                    _createElementVNode("td", _hoisted_44, _toDisplayString(formatMoney(__props.payrollDetails[index]?.centerDeductions?.unemployment)), 1),
                    _createElementVNode("td", _hoisted_45, _toDisplayString(formatMoney(__props.payrollDetails[index]?.centerDeductions?.industrialAccident)), 1),
                    _createElementVNode("td", _hoisted_46, _toDisplayString(formatMoney(__props.payrollDetails[index]?.centerDeductions?.retirement)), 1),
                    _createElementVNode("td", _hoisted_47, _toDisplayString(formatMoney(__props.payrollDetails[index]?.totalCenterDeduction)), 1),
                    _createElementVNode("td", _hoisted_48, _toDisplayString(formatMoney(__props.payrollDetails[index]?.netPay)), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("tfoot", _hoisted_49, [
                _createElementVNode("tr", _hoisted_50, [
                  _cache[2] || (_cache[2] = _createElementVNode("td", { class: "sticky-col col-name" }, "합계", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("td", { class: "col-info" }, "-", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("td", { class: "col-info" }, "-", -1)),
                  _createElementVNode("td", _hoisted_51, _toDisplayString(formatSugaHours(getTotalAllSugaHours())), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("td", { class: "col-money" }, "-", -1)),
                  _createElementVNode("td", _hoisted_52, _toDisplayString(formatMoney(getTotalAllSugaMoney())), 1),
                  _createElementVNode("td", _hoisted_53, _toDisplayString(formatMoney(getSumField('basicPay'))), 1),
                  _createElementVNode("td", _hoisted_54, _toDisplayString(formatMoney(getSumField('holidayPay'))), 1),
                  _createElementVNode("td", _hoisted_55, _toDisplayString(formatMoney(getSumField('vacationPay'))), 1),
                  _createElementVNode("td", _hoisted_56, _toDisplayString(formatMoney(getSumField('mealAllowance'))), 1),
                  _createElementVNode("td", _hoisted_57, _toDisplayString(formatMoney(getSumField('longServicePay'))), 1),
                  _createElementVNode("td", _hoisted_58, _toDisplayString(formatMoney(getSumField('bosuEduPay'))), 1),
                  _createElementVNode("td", _hoisted_59, _toDisplayString(formatMoney(getSumField('severeCareAddition'))), 1),
                  _createElementVNode("td", _hoisted_60, _toDisplayString(formatMoney(getSumField('holidayAllowance'))), 1),
                  _createElementVNode("td", _hoisted_61, _toDisplayString(formatMoney(getSumField('overtimeAllowance'))), 1),
                  _createElementVNode("td", _hoisted_62, _toDisplayString(formatMoney(getSumField('totalPay'))), 1),
                  _createElementVNode("td", _hoisted_63, _toDisplayString(formatMoney(getSumField('taxableAmount'))), 1),
                  _createElementVNode("td", _hoisted_64, _toDisplayString(formatMoney(getSumField('nonTaxableAmount'))), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["col-money col-profit group-end", getTotalProfitClass()])
                  }, _toDisplayString(formatMoney(getTotalCenterProfit())), 3),
                  _createElementVNode("td", _hoisted_65, _toDisplayString(formatMoney(getSumNestedField('employeeDeductions', 'nationalPension'))), 1),
                  _createElementVNode("td", _hoisted_66, _toDisplayString(formatMoney(getSumNestedField('employeeDeductions', 'healthInsurance'))), 1),
                  _createElementVNode("td", _hoisted_67, _toDisplayString(formatMoney(getSumNestedField('employeeDeductions', 'longTermCare'))), 1),
                  _createElementVNode("td", _hoisted_68, _toDisplayString(formatMoney(getSumNestedField('employeeDeductions', 'employmentInsurance'))), 1),
                  _createElementVNode("td", _hoisted_69, _toDisplayString(formatMoney(getSumNestedField('employeeDeductions', 'incomeTax'))), 1),
                  _createElementVNode("td", _hoisted_70, _toDisplayString(formatMoney(getSumNestedField('employeeDeductions', 'localTax'))), 1),
                  _createElementVNode("td", _hoisted_71, _toDisplayString(formatMoney(getSumField('boninPayAmount'))), 1),
                  _createElementVNode("td", _hoisted_72, _toDisplayString(formatMoney(getSumField('empEtcAmount'))), 1),
                  _createElementVNode("td", _hoisted_73, _toDisplayString(formatMoney(getSumField('supportDeduction'))), 1),
                  _createElementVNode("td", _hoisted_74, _toDisplayString(formatMoney(getSumField('totalEmployeeDeduction'))), 1),
                  _createElementVNode("td", _hoisted_75, _toDisplayString(formatMoney(getSumNestedField('centerDeductions', 'nationalPension'))), 1),
                  _createElementVNode("td", _hoisted_76, _toDisplayString(formatMoney(getSumNestedField('centerDeductions', 'healthInsurance'))), 1),
                  _createElementVNode("td", _hoisted_77, _toDisplayString(formatMoney(getSumNestedField('centerDeductions', 'longTermCare'))), 1),
                  _createElementVNode("td", _hoisted_78, _toDisplayString(formatMoney(getSumNestedField('centerDeductions', 'employmentInsurance'))), 1),
                  _createElementVNode("td", _hoisted_79, _toDisplayString(formatMoney(getSumNestedField('centerDeductions', 'unemployment'))), 1),
                  _createElementVNode("td", _hoisted_80, _toDisplayString(formatMoney(getSumNestedField('centerDeductions', 'industrialAccident'))), 1),
                  _createElementVNode("td", _hoisted_81, _toDisplayString(formatMoney(getSumNestedField('centerDeductions', 'retirement'))), 1),
                  _createElementVNode("td", _hoisted_82, _toDisplayString(formatMoney(getSumField('totalCenterDeduction'))), 1),
                  _createElementVNode("td", _hoisted_83, _toDisplayString(formatMoney(getSumField('netPay'))), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})